import { MenuItem } from '../menu';

export const everythingElseMenuItem: MenuItem = {
  id: 'everything-else',
  link: '',
  displayName: 'etc',
  customClasses: [],
  items: [
    {
      id: 'bands',
      link: '',
      displayName: 'Bands',
      customClasses: [],
      items: [
        {
          id: 'spotify',
          link: 'https://open.spotify.com/artist/0PfHJAlpEVJcWdM5ZUzChk',
          displayName: 'Spotify',
          customClasses: [],
          items: [],
        },
        {
          id: 'soundcloud',
          link: 'https://soundcloud.com/enderrr_beatsss',
          displayName: 'Soundcloud',
          customClasses: [],
          items: [],
        },
        {
          id: 'fluffer',
          link: 'https://fluffer.bandcamp.com/',
          displayName: 'Fluffer',
          customClasses: [],
          items: [],
        },
        {
          id: 'Enderrr',
          link: 'https://open.spotify.com/artist/0PfHJAlpEVJcWdM5ZUzChk',
          displayName: 'enderrr',
          customClasses: [],
          items: [],
        },
        {
          id: 'mungbean',
          link: 'https://www.mungbeanmusic.com/',
          displayName: 'Mungbean',
          customClasses: [],
          items: [],
        },
      ],
    },
    {
      id: 'builds',
      link: '',
      displayName: 'Builds',
      customClasses: [],
      items: [
        {
          id: 'blink',
          link: 'https://www.aggregatedesign.co/work/thecolosseum',
          displayName: "'The Colliseum' Art Installation",
          customClasses: [],
          items: [],
          info: 'Using my tech skills and audio production background, I helped some design/fabricator collaborators to create an interactive and immersive live event experience. ** I used DMX driven lights, some custom Python code and alot of elbow grease to create one of the most memorable installations at the bi-annual Cincinnati BLINK! festival.',
        },
        {
          id: 'dream-machine',
          link: 'https://vimeo.com/229144600',
          displayName: "'The Dream Machine' Art Installation",
          customClasses: [],
          items: [],
          info: `Doing installation work is one of my favorite things as an audio producer. Maybe it is from playing in bands my whole life. Either way, I helped collaborate with HP Innovation to create this gigantic masterpiece, debuted at New York City's "Panorama Music Festival."
            ** We used Max for Live and Ableton all hidden away in the installation to drive the music and instrumentation. What started out with alot of frustrated hours of coding, ended with something truly magical. Watching people's faces when they interacted with the machine was very gratifying. 
            ** I hope that I can continue work like this in the future.`,
        },
        {
          id: 'art-prize',
          link: '',
          displayName: 'Art Prize | Telephone Booth Installation',
          customClasses: [],
          items: [],
          info: 'Coming Soon!',
        },
      ],
    },
    {
      id: 'blog',
      link: '',
      displayName: 'Blog',
      customClasses: [],
      items: [
        {
          id: 'medium',
          link: '',
          displayName: 'My Medium',
          customClasses: [],
          items: [],
          info: 'Coming Soon!',
        },
        {
          id: 'value-statement',
          link: '',
          displayName: 'My Value Statement',
          customClasses: [],
          items: [],
          info: `In my career I have kept three things to heart.  Be creative, stay curious and always challenge yourself.  In my life so far I have had some amazing opportunities to apply creativity to an ever-changing landscape of projects. 
            ** My journey so far has seen my music on national TV, over 400 shows touring across the country and living and working in some of the most exciting cities around the world.  All the while, I haven’t lost sight of the big picture and what I am passionate about: using my skills to better understand society and hopefully help make it a better place. 
            ** I came to technology in a roundabout way but a way but everyday it seems more like it made sense all along.  Every job I’ve had, I have been magnetically drawn to the technology behind the scenes. 
            ** The age of the internet has brought with it more modern more complex problems.  Complex problems require informed and thoughtful solutions. I look forward to using my ever-growing horizon of skills to help others interact with their environment and understand each other in new and compelling ways.
            `,
        },
        {
          id: 'podcasts',
          link: '',
          displayName: 'Podcasts',
          customClasses: [],
          items: [],
          info: 'Coming Soon!',
        },
      ],
    },
  ],
};
